import { FirebaseDocRefType } from 'firebase/index'
import { StoreBreadType } from 'types/storeBread'

const fetchBreadRefsByManufacturerRef = async (
  storeRef: FirebaseDocRefType,
  manufacturerRef: FirebaseDocRefType
): Promise<FirebaseDocRefType[]> => {
  const breadRefs: FirebaseDocRefType[] = []
  await storeRef
    .collection('store_breads')
    .where('manufacturer_ref', '==', manufacturerRef)
    .get()
    .then((snapshots) => {
      snapshots.forEach((snapshot) => {
        const data = snapshot.data() as StoreBreadType
        breadRefs.push(data.bread_ref)
      })
    })
  return breadRefs
}

export default fetchBreadRefsByManufacturerRef
